<template>
  <v-container>
    <v-toolbar color="transparent" class="mb-10" flat>
      <v-icon class="mr-3">tune</v-icon>
      <v-toolbar-title>
        {{ $t('Page.Grid.header') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('finish')" color="primary">
        <v-icon left>check</v-icon>
        {{ $t('Global.Action.finish') }}
      </v-btn>
    </v-toolbar>
    <!-- SPLIT MODE CONTROLS -->
    <v-row>
      <v-col cols="3">
        <v-btn-toggle v-model="splitMode" mandatory>
          <v-btn>
            <v-icon>horizontal_split</v-icon>
          </v-btn>
          <v-btn>
            <v-icon>vertical_split</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="6" v-if="splitMode === 1">
        <v-slider
          v-model="splitSize"
          max="9"
          min="3"
          step="1"
          ticks="always"
          tick-size="4"
          hide-details
        ></v-slider>
      </v-col>
    </v-row>
    <!-- LAYOUT RENDER -->
    <v-row>
      <v-col v-for="(column, indexCol) in layout" cols="12" :key="'col_' + indexCol" :lg="column.size" class="col-padding-override">
        <v-row v-for="(row, indexRow) in column.rows" :key="'col_' + indexCol + 'row_' + indexRow">
          <v-col cols="12" class="col-padding-override">
            <PageLayoutEditorRow 
              :objects="row.objects" 
              :height.sync="row.height" 
              :size="column.size"
              @add:object="addObject(indexCol, indexRow)"
              @remove:object="indexObj => removeObject(indexCol, indexRow, indexObj)"
              @delete="deleteRow(indexCol, indexRow)"
              @clean="cleanRow(indexCol, indexRow)"
            />
          </v-col>
        </v-row>
        <!-- NEW ROW -->
        <v-row>
          <v-col cols="12">
            <v-card height="100" color="primary" outlined dark class="py-6" @click="addRow(indexCol)" hover>
              <h4 class="text-h4 text-center">
                <v-icon x-large>add</v-icon>
                {{ $t('Page.Grid.addRow') }}
              </h4>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { 
  DEFAULT_ROW_HEIGHT,
  DEFAULT_COL_SIZE,
  DEFAULT_SPLIT_SIZE, 
} from '@/config/page'
import PageLayoutEditorRow from '@/components/Page/PageLayoutEditorRow'

export default {
  name: 'PageLayoutEditor',
  components: {PageLayoutEditorRow},
  props: {
    layout: {type: Array, required: true},
  },
  computed: {
    splitMode: {
      get () {
        return this.layout.length > 1 ? 1 : 0
      },
      set (value) {
        if (value === 1) {
          this.layout[0].size = DEFAULT_SPLIT_SIZE
          this.layout.push({
            size: DEFAULT_SPLIT_SIZE,
            rows: []
          })
        } else {
          this.layout.splice(1, 1)
          this.layout[0].size = DEFAULT_COL_SIZE
        }
      }
    },
    splitSize: {
      get () {
        return this.layout[0].size
      },
      set (value) {
        this.layout[0].size = value
        this.layout[1].size = DEFAULT_COL_SIZE - value
      }
    }
  },
  methods: {
    addRow(indexCol) {
      this.layout[indexCol].rows.push({height: DEFAULT_ROW_HEIGHT, objects: []})
      this.addObject(indexCol, this.layout[indexCol].rows.length - 1)
    },
    deleteRow(indexCol, indexRow) {
      this.layout[indexCol].rows.splice(indexRow, 1)
    },
    cleanRow(indexCol, indexRow) {
      this.layout[indexCol].rows[indexRow].objects.splice(1, this.layout[indexCol].rows[indexRow].objects.length - 1)
    },
    addObject(indexCol, indexRow) {
      this.layout[indexCol].rows[indexRow].objects.push({
        type: 'blank'
      })
    },
    removeObject(indexCol, indexRow, indexObj) {
      this.layout[indexCol].rows[indexRow].objects.splice(indexObj, 1)
    }
  },
  created () {
    if (!this.layout.length) {
      this.layout.push({size: DEFAULT_COL_SIZE, rows: []})
    }
  }
}
</script>

<style scoped>
/** To allow col alignment */
.col-padding-override {
  padding: 10px!important;
}
</style>